import { ManuteRequestConfig } from '@/api/types';
import { EventQueryParams, EventRequest } from '@/api/requests/calendar/types';

/**
 * Request to find all events of a calendar.
 * @param {string|number} calendarId
 * @param {EventQueryParams} params
 */
export const ALL = (calendarId: string | number, params?: EventQueryParams): ManuteRequestConfig => ({
    method: 'GET',
    url: `/calendars/${calendarId}/events`,
    params,
});

/**
 * Request to find an event by id.
 * @param {string|number} calendarId
 * @param {string|number} eventId
 */
export const FIND = (calendarId: string | number, eventId: string | number): ManuteRequestConfig => ({
    method: 'GET',
    url: `/calendars/${calendarId}/events/${eventId}`,
});

/**
 * Request to move an event to another calendar.
 * @param {string|number} calendarId
 * @param {string|number} eventId
 * @param {EventRequest} destination
 */
export const MOVE = (
    calendarId: string | number,
    eventId: string | number,
    destination: string | number): ManuteRequestConfig => ({
    method: 'POST',
    url: `/calendars/${calendarId}/events/${eventId}/move`,
    params: {
        destination,
    },
});

/**
 * Request to save a new event.
 * @param {string|number} calendarId
 * @param {EventRequest} event
 */
export const SAVE = (calendarId: string | number, event: EventRequest): ManuteRequestConfig => ({
    method: 'POST',
    url: `/calendars/${calendarId}/events`,
    data: event,
});

/**
 * Request to update an existing event.
 * @param {string|number} calendarId
 * @param {string|number} eventId
 * @param {EventRequest} event
 */
export const UPDATE = (
    calendarId: string | number,
    eventId: string | number,
    event: EventRequest): ManuteRequestConfig => ({
    method: 'PUT',
    url: `/calendars/${calendarId}/events/${eventId}`,
    data: event,
});

/**
 * Request to delete an event.
 * @param {string|number} calendarId
 * @param {string|number} eventId
 */
export const DESTROY = (calendarId: string | number, eventId: string | number): ManuteRequestConfig => ({
    method: 'DELETE',
    url: `/calendars/${calendarId}/events/${eventId}`,
});
